import { Dispatch, MiddlewareAPI } from 'redux'
import { batch } from 'react-redux'
import { UiActionTypes } from '../types/ui'
import {
  RESET_BATCH_DATA,
  RESET_LOOKUP,
  BATCH_LIST_MOVE_UP,
  BATCH_LIST_MOVE_DOWN,
  setBatchLookupStage,
  setBatchLookupTimeouts,
  setBatchLookupValues,
  setBatchProgressError,
  setCurrentBatchId,
  setDirectUrl,
  setInitialProductValues,
  setLastAction,
  setLookupValues,
  updateBatchProgress,
} from '../actions/ui'
import {
  populateBatchProducts,
  setBatchPhotos,
  setBatchProducts,
  setBrandSearchMode,
  setPhotos,
  setProducts,
} from '../actions/products'
import { setBatchProductAliases, updateBatchAliasAssignments } from '../actions/productAliases'

const resetBatchDataMiddleware =
  ({ dispatch }: { dispatch: Dispatch }) =>
  (next: Dispatch) =>
  async (action: UiActionTypes) => {
    const result = next(action)

    if (action.type === RESET_BATCH_DATA) {
      batch(() => {
        dispatch(setBatchProducts(null))
        dispatch(setBatchPhotos(null))
        dispatch(setBatchProductAliases(null))
        dispatch(updateBatchAliasAssignments(null))
        dispatch(setBatchLookupValues(null))
        dispatch(updateBatchProgress(null))
        dispatch(setBatchProgressError(null))
        dispatch(setCurrentBatchId(null))
        dispatch(setBatchLookupTimeouts(null))
        dispatch(setBatchLookupStage({ stage: 'upload' }))
        dispatch(setLookupValues(null))
        dispatch(setProducts(null))
        dispatch(setDirectUrl({ url: '' }))
        dispatch(setBrandSearchMode({ mode: 'phonetic' }))
      })
    }

    return result
  }

const resetLookupMiddleware =
  ({ dispatch }: { dispatch: Dispatch }) =>
  (next: Dispatch) =>
  async (action: UiActionTypes) => {
    const result = next(action)

    if (action.type === RESET_LOOKUP) {
      batch(() => {
        dispatch(setLookupValues(null))
        dispatch(setProducts(null))
        dispatch(setPhotos(null))
        dispatch(setInitialProductValues(null))
        dispatch(setDirectUrl({ url: '' }))
        dispatch(setLastAction({ mode: 'lookup' }))
      })
    }

    return result
  }

const batchListNavigations =
  (store: MiddlewareAPI) => (next: Dispatch) => async (action: UiActionTypes) => {
    const result = next(action)
    const currentBatchId: string = store.getState().ui.currentBatchId
    const batchLookupValues: [] = store.getState().ui.batchLookupValues

    if (action.type === BATCH_LIST_MOVE_UP && currentBatchId && parseInt(currentBatchId) > 0) {
      store.dispatch(
        populateBatchProducts({
          batchId: (parseInt(currentBatchId) - 1).toString(),
        })
      )
    }

    if (
      action.type === BATCH_LIST_MOVE_DOWN &&
      currentBatchId &&
      parseInt(currentBatchId) < batchLookupValues.length - 1
    ) {
      store.dispatch(
        populateBatchProducts({
          batchId: (parseInt(currentBatchId) + 1).toString(),
        })
      )
    }

    return result
  }

export const uiMiddlewares = [resetBatchDataMiddleware, resetLookupMiddleware, batchListNavigations]
